import { render, staticRenderFns } from "./ThreadMessageSkeleton.vue?vue&type=template&id=2cb02c9a&scoped=true"
import script from "./ThreadMessageSkeleton.vue?vue&type=script&lang=ts"
export * from "./ThreadMessageSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ThreadMessageSkeleton.vue?vue&type=style&index=0&id=2cb02c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb02c9a",
  null
  
)

export default component.exports